(function(){
  var d=document;
  // nagłówek
  var hdr=d.querySelector('.hdr');
  var onScroll=function(){ if(hdr) hdr.classList.toggle('scrolled',window.scrollY>10);
    var sb=d.querySelector('.stickybuy'), anchor=d.querySelector('[data-buy-anchor]');
    if(sb&&anchor){ var r=anchor.getBoundingClientRect(); sb.classList.toggle('on', r.bottom<0); }
  };
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  // pojawianie przy scrollu
  var els=[].slice.call(d.querySelectorAll('.rv,footer.foot,svg.art'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(el){io.observe(el)});
  } else els.forEach(function(el){el.classList.add('in')});

  // hero
  var stage=d.querySelector('.hero-stage');
  if(stage){
    var slides=[].slice.call(stage.querySelectorAll('.slide')), bars=[].slice.call(stage.querySelectorAll('.bars button')), cur=d.querySelector('.counter b'), i=0, t;
    var go=function(n){
      i=(n+slides.length)%slides.length;
      slides.forEach(function(s,k){s.classList.toggle('is-on',k===i); s.setAttribute('aria-hidden',k===i?'false':'true');});
      bars.forEach(function(b,k){b.classList.remove('on','done'); void b.offsetWidth; if(k<i)b.classList.add('done'); if(k===i)b.classList.add('on'); b.setAttribute('aria-current',k===i?'true':'false');});
      stage.setAttribute('data-tone',slides[i].getAttribute('data-tone'));
      if(cur) cur.textContent=('0'+(i+1)).slice(-2);
      clearTimeout(t); if(!stage.hasAttribute('data-paused')) t=setTimeout(function(){go(i+1)},6500);
    };
    bars.forEach(function(b,k){b.addEventListener('click',function(){go(k)})});
    stage.addEventListener('mouseenter',function(){stage.setAttribute('data-paused','');clearTimeout(t);bars[i]&&bars[i].classList.add('done')});
    stage.addEventListener('mouseleave',function(){stage.removeAttribute('data-paused');go(i)});
    var sx=null; stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    stage.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx; if(Math.abs(dx)>40) go(i+(dx<0?1:-1)); sx=null;});
    go(0);
  }

  // zakładki (generyczne)
  [].forEach.call(d.querySelectorAll('[role=tablist]:not(.pdp-motif-tabs)'),function(list){
    var tabs=[].slice.call(list.querySelectorAll('[role=tab]'));
    tabs.forEach(function(tab){tab.addEventListener('click',function(){
      tabs.forEach(function(x){var on=x===tab; x.setAttribute('aria-selected',on); x.tabIndex=on?0:-1; var p=d.getElementById(x.getAttribute('aria-controls')); if(p){p.hidden=!on; if(on)[].forEach.call(p.querySelectorAll('.rv'),function(r){r.classList.add('in')});}});
    });});
  });

  // przełączniki aria-pressed w grupach
  [].forEach.call(d.querySelectorAll('[data-group]'),function(g){
    var multi=g.hasAttribute('data-multi');
    g.addEventListener('click',function(e){var b=e.target.closest('button'); if(!b||!g.contains(b))return;
      if(multi){b.setAttribute('aria-pressed',b.getAttribute('aria-pressed')==='true'?'false':'true');}
      else{[].forEach.call(g.querySelectorAll('button'),function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});}
      g.dispatchEvent(new CustomEvent('pick',{detail:b}));
    });
  });

  // lupa haftu
  var lens=d.querySelector('.lens');
  if(lens){var img=lens.querySelector('img'),gl=lens.querySelector('.glass'),z=2.6;
    var set=function(px,py){var r=lens.getBoundingClientRect();gl.style.left=px*100+'%';gl.style.top=py*100+'%';gl.style.backgroundImage='url('+img.currentSrc+')';gl.style.backgroundSize=(r.width*z)+'px '+(r.height*z)+'px';gl.style.backgroundPosition=(-(px*r.width*z-110))+'px '+(-(py*r.height*z-110))+'px';};
    var ready=function(){set(.575,.46)}; if(img.complete)ready(); else img.addEventListener('load',ready);
    lens.addEventListener('mousemove',function(e){var r=lens.getBoundingClientRect();set((e.clientX-r.left)/r.width,(e.clientY-r.top)/r.height)});
    window.addEventListener('resize',ready);
  }

  // katalog: filtry (obszar, rodzaj, rozmiar, kolor) + ?obszar= z adresu
  var cg=d.querySelector('.cgrid');
  if(cg){
    var cards=[].slice.call(cg.querySelectorAll('.card')), boxes=[].slice.call(d.querySelectorAll('.filters input[name=area]')), kinds=[].slice.call(d.querySelectorAll('.filters input[name=kind]')),
        chips=[].slice.call(d.querySelectorAll('.chips .chip')), cnts=[].slice.call(d.querySelectorAll('[data-count]')), empty=d.querySelector('[data-cempty]'),
        fs=d.querySelector('[data-fsize]'), fc=d.querySelector('[data-fcolor]');
    var on=function(g){return g?[].slice.call(g.querySelectorAll('[aria-pressed=true]')).map(function(b){return b.dataset.v}):[]};
    var apply=function(){
      var a=boxes.filter(function(x){return x.checked}).map(function(x){return x.value}), k=kinds.filter(function(x){return x.checked}).map(function(x){return x.value}), sz=on(fs), co=on(fc);
      chips.forEach(function(c){c.setAttribute('aria-pressed',(a.length===0&&c.dataset.area==='')||(a.length===1&&a[0]===c.dataset.area)?'true':'false')});
      var n=0;
      cards.forEach(function(c){
        var ok=(!a.length||a.indexOf(c.dataset.area)>=0)&&(!k.length||k.indexOf(c.dataset.kind)>=0)
          &&(!sz.length||sz.some(function(z){return (' '+c.dataset.sizes+' ').indexOf(' '+z+' ')>=0}))
          &&(!co.length||co.some(function(z){return (' '+c.dataset.colors+' ').indexOf(' '+z+' ')>=0}));
        c.classList.toggle('hide',!ok); if(ok){n++;c.classList.add('in');}
      });
      var any=a.length||k.length||sz.length||co.length;
      cnts.forEach(function(x){x.textContent=n}); if(empty)empty.hidden=n>0;
      [].forEach.call(cg.querySelectorAll('.edit'),function(e){e.style.display=any?'none':''});
    };
    boxes.concat(kinds).forEach(function(b){b.addEventListener('change',apply)});
    [fs,fc].forEach(function(g){g&&g.addEventListener('pick',apply)});
    chips.forEach(function(c){c.addEventListener('click',function(){var a=c.dataset.area?[c.dataset.area]:[];boxes.forEach(function(b){b.checked=a.indexOf(b.value)>=0});apply();})});
    [].forEach.call(d.querySelectorAll('[data-freset]'),function(r){r.addEventListener('click',function(){boxes.concat(kinds).forEach(function(b){b.checked=false});[fs,fc].forEach(function(g){g&&[].forEach.call(g.querySelectorAll('button'),function(b){b.setAttribute('aria-pressed','false')})});apply();})});
    var ff=d.querySelector('.ffab button'), fl=d.querySelector('.filters');
    if(ff&&fl) ff.addEventListener('click',function(){fl.classList.toggle('open'); ff.setAttribute('aria-expanded',fl.classList.contains('open'));});
    var qa=new URLSearchParams(location.search).get('obszar')||(location.hash||'').slice(1);
    if(qa&&boxes.some(function(b){return b.value===qa})){boxes.forEach(function(b){b.checked=b.value===qa});}
    apply();
  }

  // menu mobilne (strony karty 2 obsługuje pages.js)
  var dr=d.getElementById('pg-drawer'), ob=d.querySelector('[data-drawer-open]');
  if(dr&&ob&&!d.querySelector('script[src*="pages.js"]')){
    var dOpen=function(){dr.classList.add('on');dr.setAttribute('aria-hidden','false');ob.setAttribute('aria-expanded','true');d.body.classList.add('lock');var x=dr.querySelector('[data-drawer-close]');x&&x.focus();};
    var dClose=function(){dr.classList.remove('on');dr.setAttribute('aria-hidden','true');ob.setAttribute('aria-expanded','false');d.body.classList.remove('lock');};
    ob.addEventListener('click',dOpen);
    [].forEach.call(dr.querySelectorAll('[data-drawer-close]'),function(b){b.addEventListener('click',dClose)});
    dr.addEventListener('click',function(e){if(e.target===dr)dClose();});
    d.addEventListener('keydown',function(e){if(e.key==='Escape'&&dr.classList.contains('on'))dClose();});
  }

  // licznik torby w nagłówku
  var bagCount=function(e){var set=function(n){[].forEach.call(d.querySelectorAll('.tools .cnt'),function(c){c.textContent=n;c.parentNode.setAttribute('aria-label','Torba, '+n+' szt.')});};
    if(e&&e.detail&&typeof e.detail.count==='number'){set(e.detail.count);return;}
    var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(R+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){var n=0;(c.items||[]).forEach(function(i){if(i.handle!=='altivest-doplata-tekst')n+=i.quantity||0});set(n)}).catch(function(){});};
  bagCount(); window.addEventListener('altivest:cart-change',bagCount); window.addEventListener('storage',bagCount);
})();
